import { render, staticRenderFns } from "./motifs.vue?vue&type=template&id=44a0040a&"
import script from "./motifs.vue?vue&type=script&lang=js&"
export * from "./motifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports